<template>
  <div class="max-w-full" :class="[backgroundColor, width, height]">
  </div>
</template>

<script>
export default {
    name: 'Skeleton',
    props: {
        backgroundColor: {
            type: String,
        },
        width: {
            type: String,
        },
        height: {
            type: String,
        },
    }
}
</script>

<style>

</style>
